import { Event } from 'main.core';


class NewsListDocs extends Event.EventEmitter
{
	constructor(options = {})
	{
		super();

		this.containerId = options.containerId || '';
		this.tableId = options.tableId || '';
		this.ajaxId = options.ajaxId || '';

		BX.ready(BX.delegate(this.init,this));
	}

	init()
	{
		this.container = document.querySelector('#'+this.containerId);
		this.table = this.container.querySelector('#'+this.tableId);
		this.pagination = [...this.container.querySelectorAll('[data-entity="pagination"]')];

		Event.EventEmitter
			.subscribe(
				'filter_change',
				this.filterChangeHandler.bind(this)
			);
	}

	filterChangeHandler()
	{
		BX.ajax({
			url: window.location.href,
			data: {
				'ajaxId': this.ajaxId
			},
			processData: false,
			method: 'POST',
			dataType: 'html',
			onsuccess: (data) => {
				var i;
				data = BX.parseJSON(data);

				this.table.innerHTML = data.items;

				for (i in this.pagination) {
					this.pagination[i].innerHTML = data.pagination;
				}
			},
		});
	}
}

export { NewsListDocs };
